/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_widgets.js                                                                              */
/**********************************************************************************************************************/
/* Subscriptions Widgets */
HafasWebview.prototype.subscriptions = {};
HafasWebview.prototype.subscriptions.webviews = function (_me) {
  // Verbindungsanfrage wird angezeigt
  Hafas.ps.sub('/webview/init', Hafas.bind(_me.Controller.Webviews.init, _me));

  Hafas.ps.sub('/webviews/lineoverview/toggleFavorite', Hafas.bind(_me.Controller.Webviews.lineoverview.toggleFavorite,_me));
  Hafas.ps.sub('/webviews/lineoverview/toggleHimMessages', Hafas.bind(_me.Controller.Webviews.lineoverview.toggleHimMessages,_me));
};
